import { inject, type InjectionKey } from 'vue'

import type { OperacoesCatalogoEmpregador } from '../catalogo-empregador.tipos'

export const CHAVE_OPERACOES_CATALOGO_EMPREGADOR:
InjectionKey<OperacoesCatalogoEmpregador> = Symbol(
  'operacoes-catalogo-empregador',
)

export const usarOperacoesCatalogoEmpregador = (
): OperacoesCatalogoEmpregador => {
  const operacoes = inject(CHAVE_OPERACOES_CATALOGO_EMPREGADOR)
  if (!operacoes) {
    throw new Error('Catalogo de empregador nao foi instalado')
  }
  return operacoes
}
